// Greenhold component prototype: <DossierShopCard>. Story 2.7.
//
// Mounted at /prototype/dossier-shop-card (no guard) per UX-DR
// Component Implementation Strategy — the team's MVP-Storybook
// substitute. Shows four card states side-by-side for visual review:
//   * standard regular (no warning, no cap)
//   * standard special (no warning, per_user_cap=10)
//   * retiring with "2 weeks left" warning
//   * welcome variant (forward-compat preview — not used in production
//     because the public shop excludes is_perpetual=true drops)

import { DossierShopCard, type DossierShopCardDrop } from "@greenhold/components";

const mockRegular: DossierShopCardDrop = {
  drop_id: "11111111-1111-1111-1111-111111111111",
  portfolio_title: "Spring Showcase",
  portfolio_theme: "Counter-Strike",
  kind: "regular",
  status: "live",
  price_cents: 500,
  creator_count: 24,
  first_creator_names: ["Tama", "Sjokz", "Kaspar", "Marie"],
  retiring_at: null,
};

const mockSpecial: DossierShopCardDrop = {
  drop_id: "22222222-2222-2222-2222-222222222222",
  portfolio_title: "Worlds 26 Showdown",
  portfolio_theme: "League of Legends",
  kind: "special",
  status: "live",
  price_cents: 1500,
  per_user_cap: 10,
  creator_count: 12,
  first_creator_names: ["Caps", "Faker", "Doinb", "Knight"],
  retiring_at: null,
};

const mockRetiring: DossierShopCardDrop = {
  drop_id: "33333333-3333-3333-3333-333333333333",
  portfolio_title: "Holiday Heroes",
  portfolio_theme: "Old School RuneScape",
  kind: "regular",
  status: "retiring",
  price_cents: 750,
  creator_count: 18,
  first_creator_names: ["Jankos", "Rekkles", "Hans Sama", "Upset"],
  retiring_at: new Date(Date.now() + 14 * 24 * 60 * 60 * 1000).toISOString(),
};

const mockWelcome: DossierShopCardDrop = {
  drop_id: "44444444-4444-4444-4444-444444444444",
  portfolio_title: "Welcome to Greenhold",
  portfolio_theme: "Valorant",
  kind: "welcome",
  status: "live",
  price_cents: 0,
  creator_count: 20,
  first_creator_names: ["Alpha", "Beta", "Gamma", "Delta"],
  retiring_at: null,
};

export function DossierShopCardPrototype() {
  return (
    <main className="min-h-screen bg-brand-paper-100 text-brand-forest-900 p-8">
      <div className="max-w-6xl mx-auto">
        <h1 className="text-3xl font-heading font-bold mb-2">
          &lt;DossierShopCard&gt; prototype
        </h1>
        <p className="opacity-80 mb-8">
          Story 2.7 — four rendered states for visual verification (UX spec
          §3.5 / UX-DR17). The public dossier-shop page composes these into a
          responsive grid; welcome variant is forward-compat only (the public
          shop excludes is_perpetual=true drops).
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          <section>
            <h2 className="text-sm uppercase tracking-wider font-mono opacity-70 mb-3">
              regular · live
            </h2>
            <DossierShopCard drop={mockRegular} />
          </section>

          <section>
            <h2 className="text-sm uppercase tracking-wider font-mono opacity-70 mb-3">
              special · live · per_user_cap=10
            </h2>
            <DossierShopCard drop={mockSpecial} />
          </section>

          <section>
            <h2 className="text-sm uppercase tracking-wider font-mono opacity-70 mb-3">
              regular · retiring (2 weeks left)
            </h2>
            <DossierShopCard drop={mockRetiring} />
          </section>

          <section>
            <h2 className="text-sm uppercase tracking-wider font-mono opacity-70 mb-3">
              welcome (forward-compat; not used in production)
            </h2>
            <DossierShopCard drop={mockWelcome} />
          </section>
        </div>
      </div>
    </main>
  );
}
